const PAGE_SIZE = 500;

// batch fetch to avoid timeouts
export const fetchAllPages = async <T>(
  fetchPage: (first: number, offset: number) => Promise<{ nodes: T[]; totalCount: number }>,
): Promise<T[]> => {
  let offset = 0;
  let totalCount = 0;
  const nodes: T[] = [];

  do {
    // eslint-disable-next-line no-await-in-loop
    const page = await fetchPage(PAGE_SIZE, offset);
    totalCount = page.totalCount;
    nodes.push(...page.nodes);
    offset += PAGE_SIZE;
  } while (offset < totalCount);

  return nodes;
};
